import React, { Component } from "react";
import Helmet from "react-helmet";

import CoursesToLearn from "./components/coursesToLearn";
import Features from "./components/features";
import Reviews from "./components/reviews";
import LearnNow from "../shared/learnNow/learnNow";
import MediaAboutUs from "./components/mediaAboutUs";
import Welcome from "./components/welcome/welcome";

class Landing extends Component {
  constructor(props) {
    super();
  }

  componentDidMount() {
    const script1 = document.createElement("script");
    const script2 = document.createElement("script");

    script1.src = `${process.env.PUBLIC_URL}/js/landing/particles.min.js`;
    script1.async = false;

    script2.src = `${process.env.PUBLIC_URL}/js/landing/script.js`;
    script2.async = false;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
  }

  render() {
    return (
      <div>
        <Helmet>
          <title>{"Duomly - Online School"}</title>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content={
              "Upgrade your skills with bite-sized lessons in career growth, management, sales, marketing, IT & AI, and personal growth. Transform your learning with Duomly!"
            }
          />
          <meta property="og:type" content="website" />
          <meta property="og:title" content={"Duomly - Online School"} />
          <meta
            property="og:description"
            content={
              "Duomly is an e-learning platform providing programming courses for everyone. We are focusing mainly on the hottest areas of programming: Machine Learning, Blockchain, and Web Development. With Duomly users can not only learn the theory but also challenge in code tasks in most of the lessons. Our mission is to bring programming knowledge to everyone and make technology more friendly to people. Duomly wants to prove that everybody can get involved in the programming ensuring a smooth and pleasant way of learning"
            }
          />
          <meta property="og:url" content={"https://www.duomly.com/"} />
        </Helmet>
        <Welcome />
        <CoursesToLearn />
        <Features />
        <MediaAboutUs />
        <Reviews />
        <LearnNow />
      </div>
    );
  }
}

export default Landing;
